  <template>
  	<el-container class="home-container">
  		<!-- 头部 -->
  		<el-header>
  			<div>
  				<div class="images">

  				</div>
  				<span>管理端V1.0</span>
  				<span>{{fsmm||''}}-{{phone||''}}</span>
  			</div>

  			<el-button type="info" @click="tiaozhuan('login')">退出</el-button>
  		</el-header>
  		<el-container>
  			<!-- 侧边 -->
  			<el-aside :width="isshwo ? '64px' : '200px'">
  				<div class="toggre" @click="toggre">|||</div>
  				<el-menu default-active='3' background-color="#323744" text-color="#fff" active-text-color="#369bff"
  					:unique-opened="true" :collapse="isshwo" :collapse-transition="true">
  					<!--         <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-s-custom"></i>
              <span slot="title">账套管理 </span>
            </template>
          
            <el-menu-item-group class="el-menu-item-group">
              <el-menu-item index="1-4" @click="tiaozhuan('user')">
                <i class="el-icon-menu"></i>
                <span slot="title">账套管理</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu> -->
  					<el-submenu index="3">
  						<template slot="title">
  							<i class="el-icon-s-order"></i>
  							<span slot="title">信息查询 </span>
  						</template>
  						<el-menu-item-group class="el-menu-item-group">
  							<el-menu-item index="3-1" @click="tiaozhuan('xxcx')">
  								<i class="el-icon-menu"></i>
  								<span slot="title">发送消息记录</span>
  							</el-menu-item>
  						</el-menu-item-group>

  						<el-menu-item-group class="el-menu-item-group">
  							<el-menu-item index="3-2" @click="tiaozhuan('bdcx')">
  								<i class="el-icon-menu"></i>
  								<span slot="title">用户绑定记录</span>
  							</el-menu-item>
  						</el-menu-item-group>
  					</el-submenu>
  					<el-submenu index="2">
  						<template slot="title">
  							<i class="el-icon-s-order"></i>
  							<span slot="title">模板管理 </span>
  						</template>
  						<el-menu-item-group class="el-menu-item-group">
  							<el-menu-item index="2-1" @click="tiaozhuan('mbgg')">
  								<i class="el-icon-menu"></i>
  								<span slot="title">模板管理</span>
  							</el-menu-item>
  						</el-menu-item-group>
  					</el-submenu>

  					<el-submenu index="4">
  						<template slot="title">
  							<i class="el-icon-s-order"></i>
  							<span slot="title">客户管理 </span>
  						</template>
  						<el-menu-item-group class="el-menu-item-group">
  							<el-menu-item index="4-1" @click="tiaozhuan('kehu')">
  								<i class="el-icon-menu"></i>
  								<span slot="title">客户管理</span>
  							</el-menu-item>
  						</el-menu-item-group>
  					</el-submenu>
  					<!-- <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span slot="title">角色管理 </span>
            </template>
            
          </el-submenu> -->
  				</el-menu>
  			</el-aside>
  			<!-- 右边主体 -->
  			<el-main><router-view /></el-main>
  		</el-container>
  	</el-container>

  	<!-- <div class="box">
    <el-container style="height: 100%; border: 1px solid #eee">
      <el-aside width="auto" class="left">
        <div class="idd" @click="toggleCollapse">
          <i class="el-icon-s-unfold"></i>
        </div>

        <el-menu
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          :collapse="isCollapse"
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span slot="title">用户管理 </span>
            </template>
            <el-menu-item-group class="el-menu-item-group">
              <el-menu-item index="1-1" @click="tiaozhuan('user')">
                <span slot="title">用户管理</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span slot="title">账套管理 </span>
            </template>
            <el-menu-item-group class="el-menu-item-group">
              <el-menu-item index="2-1" @click="tiaozhuan('st')">
                <span slot="title">账套管理</span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>

      <el-container>
        <el-header>
          <div class="logo"></div>
        </el-header>
        <router-view></router-view>
      </el-container>
    </el-container>
  </div> -->
  </template>

  <script>
  	export default {
  		name: "index",

  		data() {
  			return {
  				isCollapse: false,
  				isshwo: false,
  				phone: '',
  				fsmm: ''
  			};
  		},
  		methods: {
  			handleOpen(key, keyPath) {
  				console.log(key, keyPath);
  			},
  			handleClose(key, keyPath) {
  				console.log(key, keyPath);
  			},
  			toggleCollapse() {
  				this.isCollapse = !this.isCollapse;
  			},
  			tiaozhuan(data) {
  				if (data == "login") {
  					sessionStorage.removeItem("token");
  					sessionStorage.removeItem("ztid");
  				}
  				this.$router.push({
  					name: data
  				});
  			},
  			toPc() {
  				window.location.href = "https://www.srdrj.cn/test";
  			},

  			toggre() {
  				this.isshwo = !this.isshwo;
  			},
  		},
  		created() {
  			this.phone = sessionStorage.getItem('phone')
  			this.fsmm = sessionStorage.getItem('fsmm')
  		},

  		mounted() {

  		},
  	};
  </script>

  <style>
  	* {
  		margin: 0;
  		padding: 0;
  	}

  	/* .btn {
  height: 5%;
  margin-top: 2%;
}
.box {
  min-height: 85vh;
  background-color: #d3dce6;
}
.minbox {
  width: 90%;
  margin-left: 5%;
  background-color: aliceblue;
  height: 90vh;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}
.logo {
  line-height: 60px;
  height: 60px;
  background-image: url(../assets/logo1.png);

  background-repeat: no-repeat;
  background-position: center;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100vh;
}
.el-aside {
  color: #333;
}
.right {
  min-height: 100vh;
  background-color: #d3dce6;
  overflow: auto;
}
.left {
  min-height: 100vh;
  text-align: left;
  background-color: #545c64;
}
.idd {
  margin: 0 auto;
  text-align: center;
  font-size: 25px;
  color: #989898;
  cursor: pointer;
  line-height: 30px;
} */

  	/* .images {
  background-color: #fff;
  overflow: hidden;
  border-radius: 50%;
} */

  	.home-container {
  		height: 100vh;
  	}

  	.el-menu {
  		border-right: none;
  		width: 100%;
  	}

  	.el-submenu {
  		text-align: left;
  	}

  	.el-header {
  		background-color: #373c41;
  		display: flex;
  		justify-content: space-between;
  		padding-left: 0;
  		align-items: center;
  		color: #fff;
  		font-size: 20px;
  	}

  	.el-header>div {
  		display: flex;
  		align-items: center;
  	}

  	.el-header>div>span {
  		margin-left: 15px;
  	}

  	.el-header img {
  		width: 50px;
  		height: 50px;
  		border-radius: 50%;
  	}

  	.el-aside {
  		background-color: #323744;
  	}

  	.el-main {
  		background-color: #eee;
  	}

  	.toggre {
  		background-color: #485066;
  		color: #fff;
  		font-size: 10px;
  		line-height: 20px;
  		text-align: center;
  		letter-spacing: 0.2em;
  		cursor: pointer;
  	}
  </style>